import {createReducer} from "redux-act";
import {
	fetchSbkEligibility,
	fetchSbkEligibilityFailed,
	fetchSbkEligibilitySuccess,
	ISbkEligibility,
} from "modules/actions/sbkEligibility";
import {RequestState} from "modules/enums";

export interface ISbkEligibilityReducer {
	eligibility: ISbkEligibility | null;
	requestState: RequestState;
}

const defaultState: ISbkEligibilityReducer = {
	eligibility: null,
	requestState: RequestState.IDLE,
};

export const sbkEligibility = createReducer<ISbkEligibilityReducer>({}, defaultState)
	.on(fetchSbkEligibility, (state) => ({
		...state,
		requestState: RequestState.Requested,
	}))
	.on(fetchSbkEligibilitySuccess, (state, eligibility) => ({
		...state,
		eligibility,
		requestState: RequestState.Received,
	}))
	.on(fetchSbkEligibilityFailed, (state) => ({
		...state,
		requestState: RequestState.Received,
	}));
